import React, { useEffect, useState } from "react";
import PrivateApi from "../../services/PrivateApiService";
import { Container } from "react-bootstrap";
import { FaCircleXmark } from 'react-icons/fa6';
import Timeline from "./Timeline";

/**
 * 
 * @param {elvs} props list of elvs
 * @param {items} props list of all poolrechnungen, abrechnungen, vorschreibungen
 */
const TLineComponent = ({elvs, items, hidden, opaque}) => {

    const API = new PrivateApi();

    return (
        <Container className="mt-5" style={hidden? {display: "none"}: null}>
            {elvs.length > 0?
                elvs.map((e, i) => (
                    <Timeline key={e.id} left={(i +1) % 2 === 0} elv={e} items={items} opaque={opaque}/>
                ))
                :
                <div className="text-center">
                    <FaCircleXmark size={50} className="text-energo mb-3" />
                    <p>Es sind keine Daten zu Energielieferverträgen dieser Anlage vorhanden.</p>
                </div>
            }
        </Container>
    )
}

export default TLineComponent;